import api from './api';

const productService = {
  // Get all products with filters
  getAll: async (params = {}) => {
    const response = await api.get('/products', { params });
    return response.data;
  },

  // Get product by ID
  getById: async (id) => {
    const response = await api.get(`/products/${id}`);
    return response.data;
  },

  // Get products by category
  getByCategory: async (categoryId, params = {}) => {
    const response = await api.get('/products', {
      params: { ...params, category: categoryId },
    });
    return response.data;
  },

  // Create product (admin only)
  create: async (productData) => {
    const config = productData instanceof FormData ? { headers: { 'Content-Type': 'multipart/form-data' } } : {};
    const response = await api.post('/products', productData, config);
    return response.data;
  },

  // Update product (admin only)
  update: async (id, productData) => {
    const config = productData instanceof FormData ? { headers: { 'Content-Type': 'multipart/form-data' } } : {};
    const response = await api.put(`/products/${id}`, productData, config);
    return response.data;
  },

  // Delete product (admin only)
  delete: async (id) => {
    const response = await api.delete(`/products/${id}`);
    return response.data;
  },

  // Upload product image (admin only)
  uploadImage: async (formData) => {
    const response = await api.post('/products/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },
};

export default productService;
